// extracted by mini-css-extract-plugin
module.exports = {"container":"App_container__39S21","image":"App_image__3jVWt"};